import { useTranslation } from "react-i18next";

import { Modal } from "@/lib/components/ui/Modal/Modal";
import Button from "@/lib/components/ui/Button";

type ConfirmationModalProps = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title: string;
};

export const ConfirmationModal = ({
  isOpen,
  setOpen,
  onConfirm,
  isLoading,
  title,
}: ConfirmationModalProps): JSX.Element => {
  const { t } = useTranslation("translation");

  return (
    <Modal
      title={t("confirmAction")}
      isOpen={isOpen}
      setOpen={setOpen}
      size="auto"
      Trigger={<div />}
      CloseTrigger={<div />}
      className="!max-w-[700px]"
    >
      <p className="text-lg mt-4"> {title} </p>
      <div className="flex flex-row justify-end items-center mt-10 gap-4">
        <Button
          onClick={() => setOpen(false)}
          label={t("cancel")}
          variant="secondary"
          className="min-w-[60px]"
        />
        <Button
          onClick={onConfirm}
          isLoading={isLoading}
          variant="primary"
          label={t("confirm")}
          className="min-w-[60px]"
        />
      </div>
    </Modal>
  );
};
